import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var ManufactureListRes;
export const ManufactureListTodo = createAsyncThunk('ManufactureList', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'parent_group_list',
            data: {
                "ibusiness_area_id": localStorage.getItem("ibusiness_area_id"),
            },
            headers: { "Content-Type": "application/json" }
        })
        return ManufactureListRes = res.data

    } catch (error) {
        return ManufactureListRes = error.response.data
    }
})

const ManufactureListSlice = createSlice({
    name: 'ManufactureList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(ManufactureListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(ManufactureListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default ManufactureListSlice.reducer; 